<template>
    <div>
        <div class="wflow-container">
            <!-- <div class="header-container">
        <SidebarLogo :title="title" :logo="logo" />
      </div> -->
            <div class="header-container">
                <div style="margin-left: 22px; float: left; display: flex">
                    <svg data-v-5d08e6e2="" data-v-34d1b6f7="" aria-hidden="true" class="svg-icon" style="font-size: 36px; color: rgb(47, 71, 126); margin-right: 6px">
                        <use data-v-5d08e6e2="" xlink:href="#icon-wf_form" />
                    </svg>
                </div>
                <span
                    style="color: #999
         margin-left: 10px;
           "
                >
                    业务类型：内容发布
                </span>
                <div style="margin-right: 10px; float: right; display: flex; justify-content: flex-end">
                    <el-button :disabled="btn_dis" plain @click="closeThisDialog()">
                        <span>
                            <svg data-v-5d08e6e2="" data-v-6635f034="" aria-hidden="true" class="svg-icon glyphicon-off" style="color: red">
                                <use data-v-5d08e6e2="" xlink:href="#icon-glyphicon-off" />
                            </svg>
                            <span data-v-6635f034="">关闭</span>
                        </span>
                    </el-button>
                    <el-button v-if="canEdit === 0" :disabled="btn_dis" plain icon="el-icon-edit" @click="editObject()">修改</el-button>
                    <el-button v-if="vo.state !== null" :disabled="btn_dis" plain icon="el-icon-film" @click="openFile">预览</el-button>
                    <el-button v-if="canEdit === 1 && vo.deleteStatus !== 1" :disabled="btn_dis" plain @click="submitForm(false, null, 0, 0, 'submit')">
                        <span>
                            <svg data-v-5d08e6e2="" data-v-6635f034="" aria-hidden="true" class="svg-icon saved" style="color: #00008b">
                                <use data-v-5d08e6e2="" xlink:href="#icon-saved" />
                            </svg>
                            <span data-v-6635f034="">保存</span>
                        </span>
                    </el-button>
                    <el-button v-if="(vo.deleteStatus === 0 || vo.deleteStatus === null) && (vo.reviewStatus === null || vo.reviewStatus === 2)" :disabled="btn_dis" plain @click="submitForm(true, 0, 0, 0, 'sentto')">送审核</el-button>
                    <el-button v-if="vo.deleteStatus === 0 && vo.publishStatus === 0 && vo.reviewStatus === 0" :disabled="btn_dis" plain @click="submitForm(false, 1, 0, 0, 'sentis')">审核通过</el-button>
                    <el-button v-if="vo.deleteStatus === 0 && vo.publishStatus === 0 && vo.reviewStatus === 0" :disabled="btn_dis" plain @click="submitForm(false, 2, 0, 0, 'sentno')">审核不通过</el-button>
                    <el-button v-if="vo.publishStatus === 0" :disabled="btn_dis" plain class="submit" @click="operateConfirm(false, 'publish')">
                        <span>
                            <svg data-v-5d08e6e2="" data-v-6635f034="" aria-hidden="true" class="svg-icon">
                                <use data-v-5d08e6e2="" xlink:href="#icon-checked" />
                            </svg>
                            <span data-v-6635f034="">发布</span>
                        </span>
                    </el-button>
                    <el-button v-if="vo.deleteStatus === 0 && vo.reviewStatus === 1 && vo.publishStatus === 1" :disabled="btn_dis" plain @click="operateConfirm(false, 'cancelPublish')">取消发布</el-button>
                    <el-button v-if="vo.deleteStatus === 0 && vo.reviewStatus !== null" :disabled="btn_dis" plain icon="el-icon-delete" @click="operateConfirm(true, 'delete')">删除</el-button>
                </div>
            </div>
            <div class="mainform-container" :class="{ 'wflow-container-loaded': !loading }">
                <el-scrollbar :native="false" tag="div">
                    <div class="page-container">
                        <div v-if="loading" v-loading="loading" element-loading-text="正在加载..." />
                        <div class="form-header">
                            <div class="form-title">{{ formTitle }}</div>
                        </div>
                        <div v-if="!loading" class="form-container">
                            <el-form :model="vo">
                                <div class="el-table el-table--fit el-table--border">
                                    <div class="el-table__body-wrapper">
                                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                            <tbody>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                        <span class="required">*</span>
                                                        文章标题
                                                    </td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <ValidationProvider v-if="canEdit === 1" ref="ValidationProvider" v-slot="{ errors }" name="文章标题" rules="required">
                                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                                <el-input v-model="vo.title" name="title" placeholder="请输入文章标题" />
                                                            </el-tooltip>
                                                        </ValidationProvider>
                                                        <span v-if="canEdit === 0">{{ vo.title }}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">简略标题</td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <el-input v-if="canEdit === 1" v-model="vo.subTitle" name="subTitle" placeholder="请输入简略标题" />
                                                        <span v-if="canEdit === 0">{{ vo.subTitle }}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">标签</td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <!-- <el-input v-if="canEdit===1" v-model="vo.labels" :disabled="true" name="labels" placeholder="请输入文章来源" @click="show=true" />
                            <el-input v-if="canEdit===1" v-model="vo.labels" :disabled="true" name="labels" placeholder="请输入文章来源" @click="show=true" /> -->
                                                        <el-button v-if="canEdit === 1" @click="show = true">选择标签</el-button>
                                                        <span>{{ vo.labels }}</span>
                                                    </td>
                                                </tr>
                                                <tr v-if="type === 1 || type === 3 || type === 4">
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                        <span class="required">*</span>
                                                        封面图片
                                                    </td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <upload-img v-if="allShow" fname="logoName" type="article" fdata="logoData" :vo="vo" url="/portal/cms/article" :edit="canEdit" :show-img="showImg" />
                                                    </td>
                                                </tr>
                                                <tr v-if="vo.cateName !== '合规专题'">
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">所属分类</td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <span>{{ vo.cateName }}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">备注</td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <el-input v-if="canEdit === 1" v-model="vo.summary" type="textarea" name="summary" placeholder="请输入备注" />
                                                        <span v-if="canEdit === 0">{{ vo.summary }}</span>
                                                    </td>
                                                </tr>
                                                <tr v-if="type === 1">
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">是否头条</td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <el-radio-group v-model="vo.isHeadlines" v-can-edit>
                                                            <el-radio :label="1">是</el-radio>
                                                            <el-radio :label="0">否</el-radio>
                                                        </el-radio-group>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">创建人</td>
                                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                                        <span>{{ vo.creator }}</span>
                                                    </td>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">创建时间</td>
                                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                                        <span>{{ vo.createTime }}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">审核人</td>
                                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                                        <span>{{ vo.reviewer }}</span>
                                                    </td>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">审核时间</td>
                                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                                        <span>{{ vo.reviewTime }}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="el-table__cell tdlbl tdw17" colspan="1">发布时间</td>
                                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                                        <span>{{ vo.publishTime }}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td ref="tdlbl_附件上传" class="el-table__cell tdlbl tdw17">附件上传</td>
                                                    <td class="el-table__cell tdcont tdcont" colspan="5">
                                                        <Attachment v-if="vo.passenger" ref="attachments" :vo="vo" :can-edit="canEdit" :attachments="vo.passenger.attachments" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </el-form>
                            <RichtextEditor v-if="showckedit" v-model="vo.content" :toolbar="'full'" :height="500" :image-upload-url="base_api + '/portal/attachment/uploadBodyPicture?orgCode=' + vo.orgCode + '&module=article&busiDataId=' + vo.id + '&attachsType=BODY'" :image-browse-url="'plugins/ckeditor/plugins/image/dialogs/browsePicture.html?apiurl=' + base_api + '/portal/attachment/browsePictureSet?orgCode=' + vo.orgCode" :video-browse-url="'plugins/ckeditor/plugins/html5video/dialogs/browseVideo.html?apiurl=' + base_api + '/portal/attachment/browseVideo?orgCode=' + vo.orgCode" />
                            <!-- <div style="margin-top:20px;text-align:center">
                <el-button v-if="canEdit===0&&vo.deleteStatus===0&&(vo.reviewStatus===null||vo.reviewStatus===1||vo.reviewStatus===2)&&vo.publishStatus===0" :disabled="btn_dis" plain @click="editObject()">修改</el-button>
                <el-button v-if="canEdit===1&&vo.deleteStatus!==1" :disabled="btn_dis" plain @click="submitForm(false,null,0,0,'submit')">保存</el-button>
                <el-button v-if="(vo.deleteStatus===0||vo.deleteStatus===null)&&(vo.reviewStatus===null||vo.reviewStatus===2)" :disabled="btn_dis" plain @click="submitForm(true,0,0,0,'sentto')">送审核</el-button>
                <el-button v-if="(roles.indexOf('article_audit')>-1 || roles.indexOf('article_audit_hg')>-1)&&vo.deleteStatus===0&&vo.publishStatus===0&&vo.reviewStatus===0" :disabled="btn_dis" plain @click="submitForm(false,1,0,0,'sentis')">审核通过</el-button>
                <el-button v-if="(roles.indexOf('article_audit')>-1 || roles.indexOf('article_audit_hg')>-1)&&vo.deleteStatus===0&&vo.publishStatus===0&&vo.reviewStatus===0" :disabled="btn_dis" plain @click="submitForm(false,2,0,0,'sentno')">审核不通过</el-button>
                <el-button v-if="(roles.indexOf('article_audit')>-1 || roles.indexOf('article_audit_hg')>-1)&&vo.deleteStatus===0&&vo.reviewStatus===1&&vo.publishStatus===0" :disabled="btn_dis" plain @click="operateConfirm(false,'publish')">发布</el-button>
                <el-button v-if="(roles.indexOf('article_audit')>-1 || roles.indexOf('article_audit_hg')>-1)&&vo.deleteStatus===0&&vo.reviewStatus===1&&vo.publishStatus===1" :disabled="btn_dis" plain @click="operateConfirm(false,'cancelPublish')">取消发布</el-button>
                <el-button v-if="vo.deleteStatus===0&&vo.reviewStatus!==null" :disabled="btn_dis" plain @click="operateConfirm(true,'delete')">删除</el-button>
                <el-button :disabled="btn_dis" plain @click="closeThisDialog()">关闭</el-button>
              </div> -->
                        </div>
                    </div>
                </el-scrollbar>
            </div>
            <el-dialog title="选择标签" :visible.sync="show" width="60%">
                <el-tree :data="data" :props="defaultProps" show-checkbox @check-change="handleCheckChange" />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="show = false">取 消</el-button>
                    <el-button type="primary" @click="isOk">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
const time = new Date()
const date = moment(time).format('YYYY-MM-DD HH:mm')
const { title, logo } = require('@/wapp/settings')
export default {
    props: {},
    data() {
        return {
            uploadPromiseNum: 0,
            fileList1: [],
            title: title,
            logo: logo,
            label: [],
            labelId: [],
            show: false,
            data: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            loginUser: this.$store.getters.loginUser,
            loading: false,
            vo: {},
            canEdit: '',
            staffList: {},
            showImg: false,
            allShow: false,
            type: 1,
            param: {},
            moduleInfo: {
                addNewUrl: 'portal/cms/article/addNew',
                insertUrl: 'portal/cms/article/insert',
                updateUrl: 'portal/cms/article/update',
                getByIdUrl: 'portal/cms/article/getById',
                download: 'portal/cms/article/download',
                upload: 'portal/cms/article/upload', // 上传封面
                uploadAttach: 'portal/cms/article/uploadAttach' // 上传附件
            },
            formType: '',
            base_api: '',
            fileList: [], // 封面图片
            uploadFiles: [], // 文章附件
            formTitle: '',
            roles: [],
            showckedit: false,
            port: location.port,
            btn_dis: false,
            subTypes: [{ value: '黄金糕' }, { value: '双皮奶' }]
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$options.components['uploadImg'] = this.$loadComponent('@/wapp/xxfb/article/components/WdglArticleUploadImg.vue')

        this.$bus.on('firstUpload', this.getFile)
        this.base_api = process.env.VUE_APP_BASE_API
        this.roles = this.$store.state.user.roles
        console.log(this.roles, 'this.roles')
        this.param = this.$route.query
        this.type = Number(this.$route.query.type)
        this.formTitle = this.type === 1 ? '文章管理' : '单位公告'
        if (this.type === 3) {
            this.formTitle = '大事记'
        }
        if (this.type === 4) {
            this.formTitle = '文件制度'
        }
        this.canEdit = Number(this.param.canEdit)
        this.initForm()
        this.getLabel()
    },
    beforeDestroy() {
        this.$bus.off('firstUpload', this.getFile)
    },
    mounted() {
        const style = this.loginUser.uiStyle
        document.querySelector('body').setAttribute('id', style)
        if (!this.param.id) {
            this.loadWfInstance()
        }
    },
    methods: {
        getFile(row, fileName) {
            this.fileList = []
            this.fileList.push(row)
            this.vo.logoName = fileName
        },
        hexify(color) {
            // 颜色格式转换 =》16进制
            var values = color
                .replace(/rgba?\(/, '')
                .replace(/\)/, '')
                .replace(/[s+]/g, '')
                .split(',')
            console.log(values, 'values')
            var a = parseFloat(values[3] || 1)
            var r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255)
            var g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255)
            var b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
            return '#' + ('0' + r.toString(16)).slice(-2) + ('0' + g.toString(16)).slice(-2) + ('0' + b.toString(16)).slice(-2)
        },
        handleCheckChange(data, checked, indeterminate) {
            if (checked) {
                this.label.push(data.name)
                if (data.color && data.color.indexOf('rgb') > -1) {
                    this.labelId.push(this.hexify(data.color))
                    return
                }
                this.labelId.push(data.color)
            } else {
                if (this.label.includes(data.name)) {
                    const index = this.label.indexOf(data.name)
                    const index1 = this.labelId.indexOf(data.color)
                    this.label.splice(index, 1)
                    this.labelId.splice(index1, 1)
                }
            }
            console.log(this.labelId, 999)
        },
        handleNodeClick(data) {
            this.label = data
            console.log(data, 'data')
        },
        isOk() {
            this.vo.labels = this.label.join(',')
            this.vo.color = this.labelId.join(',')
            this.show = false
        },
        async getLabel() {
            const res = await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/portal/label/list',
                params: {
                    sysCode: this.$store.getters.loginUser.sysCode
                }
            })
            this.data = res.body.data || []
        },
        loadWfInstance() {
            if (this.loginUser.staffList.length === 0) {
                this.$alert('您的账号没有机构信息，不能创建、处理文件。', '操作提示', {
                    type: 'error',
                    callback: () => {
                        window.close()
                    }
                })
            }
        },
        openFile() {
            const row = this.vo
            this.formValidate(() => {
                if (this.vo.content === '' || this.vo.content === null) {
                    this.$alert('请填写文章内容', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                }
                if (!this.param.id) {
                    this.$alert('请先保存', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                } else {
                    if (row.id) {
                        window.open('/#/commonHeader?workform=@/wapp/xxfb/article/components/CCViewContent&background=false&wflowType=getById&showComment=false&showCollection=false&wfEngineUrl=portal/cms/article&busiDataId=' + row.id + '&viewContent=1' + '&type=zsgl&logoTitle=' + encodeURIComponent(`信息共享/新闻中心`))
                    }
                }
            })
        },
        // 初始化内容
        initForm() {
            if (!this.param.id) {
                this.formType = 'addNew'
                this.$http({
                    method: 'POSt',
                    url: this.moduleInfo.addNewUrl
                }).then((res) => {
                    if (res.code === 'success') {
                        const vo = res.body.vo
                        vo.creator = this.loginUser.personName
                        vo.creatorId = this.loginUser.personId
                        vo.createTime = date
                        vo.type = this.type
                        vo.isHeadlines = 1
                        vo.cateId = this.param.cateId
                        vo.cateName = this.param.cateName
                        vo.publishStatus = 0
                        this.vo = vo
                        if (this.vo.logoName) {
                            this.showImg = true
                        }
                        this.allShow = true
                        this.subTypes = []
                        var subTypeArr = vo.passenger.subTypeArr
                        if (subTypeArr) {
                            subTypeArr.forEach((item) => {
                                this.subTypes.push({ value: item })
                            })
                        }

                        this.showckedit = false
                        this.$nextTick(() => {
                            this.showckedit = true
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.formType = 'update'
                this.$http({
                    method: 'GET',
                    url: this.moduleInfo.getByIdUrl,
                    params: { id: this.param.id }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        if (this.vo.logoName) {
                            this.showImg = true
                        }
                        this.allShow = true
                        if (this.vo.createTime) {
                            this.vo.createTime = this.vo.createTime.substr(0, 16)
                        }
                        if (this.vo.reviewTime) {
                            this.vo.reviewTime = this.vo.reviewTime.substr(0, 16)
                        }
                        if (this.vo.publishTime) {
                            this.vo.publishTime = this.vo.publishTime.substr(0, 16)
                        }
                        this.showckedit = false
                        this.$nextTick(() => {
                            this.showckedit = true
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        submitForm(closed, reviewStatus, publishStatus, deleteStatus, type) {
            const _this = this
            this.formValidate(() => {
                if (closed === undefined) closed = false
                if (this.vo.content === '' || this.vo.content === null) {
                    this.$alert('请填写文章内容', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                }
                this.btn_dis = true
                let dialog = ''
                if (type === 'submit') {
                    dialog = '保存成功'
                } else if (type === 'sentto') {
                    dialog = '已提交送审核'
                } else if (type === 'sentis') {
                    dialog = '审核成功'
                } else if (type === 'sentno') {
                    dialog = '审核成功'
                } else if (type === 'publish') {
                    dialog = '发布成功'
                } else if (type === 'cancelPublish') {
                    dialog = '取消发布成功'
                } else if (type === 'delete') {
                    dialog = '删除成功'
                }

                if (reviewStatus !== undefined && reviewStatus !== null) {
                    this.vo.reviewStatus = reviewStatus
                    if (reviewStatus !== 0) {
                        this.vo.reviewTime = date
                        this.vo.reviewer = this.loginUser.personName
                    }
                }
                if (deleteStatus !== undefined && deleteStatus != null) {
                    this.vo.deleteStatus = deleteStatus
                    if (deleteStatus === 1) this.vo.deleteTime = date
                }
                if (publishStatus !== undefined && publishStatus != null) {
                    this.vo.publishStatus = publishStatus
                    if (publishStatus === 1) {
                        this.vo.status = 1
                        this.vo.publishTime = date
                    }
                }
                this.vo.orgCode = this.loginUser.orgCode
                this.vo.orgName = this.loginUser.orgName

                let saveUrl = ''
                let actionType = ''
                let data = []
                if (this.formType === 'addNew') {
                    saveUrl = this.moduleInfo.insertUrl
                    actionType = 'POST'
                    if (type === 'submit') {
                        this.vo.reviewStatus = null
                    }
                    data = this.vo
                } else if (this.formType === 'update') {
                    saveUrl = this.moduleInfo.updateUrl
                    actionType = 'PUT'
                    data = this.vo
                }

                this.$http({
                    method: actionType,
                    url: saveUrl,
                    data: data
                }).then((res) => {
                    if (res.code === 'success') {
                        new Promise((resolve, reject) => {
                            const attachments = _this.$attachments
                            _this.wfInstance = { moduleCode: _this.moduleCode, bodyDocId: '' }
                            attachments.uploadWflowAttach(_this).then((res) => {
                                if (res.code === 'success') {
                                    resolve(true)
                                }
                            })
                        }).then((result) => {
                            this.$nextTick(() => {
                                const btnRefresh = window.opener.document.querySelector('.el-icon-refresh')
                                if (btnRefresh !== null) btnRefresh.parentElement.click()
                                this.$bus.emit('refreshListData')
                            })
                            if (this.fileList.length > 0) {
                                this.submitFile()
                            } else {
                                this.$message({
                                    message: dialog,
                                    type: 'success'
                                })
                                setTimeout(() => {
                                    const locHttp = location.href.split('?')[0]
                                    location.href = locHttp + '?type=' + this.type + '&canEdit=0' + '&id=' + this.vo.id
                                    location.reload()
                                }, 500)
                            }

                            if (deleteStatus === 1) {
                                window.close()
                            }

                            this.btn_dis = false
                        })
                    } else {
                        this.$message.error(res.message)
                        this.btn_dis = false
                    }
                })
            })
        },
        handleUploadChange(file, fileList) {
            this.fileList = [file]
            this.vo.logoName = file.name
        },
        handleUploadError(err, file, fileList) {
            // this.uploading = false
            this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                dangerouslyUseHTMLString: true
            })
        },
        submitFile() {
            this.fileList.forEach((file) => {
                const fd = new FormData()
                fd.append('file', file)
                this.$http({
                    method: 'PUT',
                    url: this.moduleInfo.upload,
                    params: {
                        id: this.vo.id,
                        dataField: 'logoData',
                        nameField: 'logoName'
                    },
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                        setTimeout(() => {
                            const locHttp = location.href.split('?')[0]
                            location.href = locHttp + '?type=' + this.type + '&canEdit=0' + '&id=' + this.vo.id
                            location.reload()
                        }, 500)
                        this.btn_dis = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        operateConfirm(closed, actionType) {
            let msg = ''
            let reviewStatus = this.vo.reviewStatus
            let publishStatus = this.vo.publishStatus
            let deleteStatus = this.vo.deleteStatus

            if (actionType === 'delete') {
                msg = '确认要删除文章吗？'
                deleteStatus = 1
            } else if (actionType === 'cancelPublish') {
                msg = '确认要取消发布吗？'
                reviewStatus = null
                publishStatus = 0
            } else if (actionType === 'publish') {
                msg = '确认要发布文章吗？'
                publishStatus = 1
                reviewStatus = 1
            }

            if (msg !== '') {
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.submitForm(closed, reviewStatus, publishStatus, deleteStatus, actionType)
                    })
                    .catch(() => {})
            }
        },
        editObject() {
            location.href = location.href.replace('canEdit=0', 'canEdit=1')
            location.reload()
        },
        closeThisDialog() {
            window.close()
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
.header-container {
    z-index: 99;
    width: 100%;
    padding: 12px 0;
    position: relative;
    overflow: hidden;
    background: #ffffff;
    font-size: 12px;
    line-height: 36px;
    //   /deep/ .sidebar-logo-container {
    //     width: auto;
    //     margin-left: 20px;
    //     .sidebar-logo {
    //       margin-left: 0;
    //     }
    //   }
    /deep/ .sidebar-title {
        color: $headerText;
    }
}
.wflow-container {
    background-color: #f3f3f3;
    font-weight: 400;
    font-size: $contentFontSize;

    .mainform-container {
        height: calc(100vh - #{$headerHeightOuter});
        overflow-y: auto;
        /deep/ .el-scrollbar {
            width: 100%;
            height: 100%;
            .el-scrollbar__wrap {
                overflow-x: hidden;
                .el-scrollbar__view {
                    height: 100%;
                }
            }
        }

        .page-container {
            width: 1200px;
            min-height: 100%;
            background: #fff;
            margin: 0 auto;
            padding-top: 30px;
            margin-top: 10px;
            .form-header {
                .form-title {
                    font-size: 24px;
                    font-weight: normal;
                    text-align: center;
                    color: #545454;
                }

                .section-title {
                    overflow: hidden;
                    // height: 22px;
                    line-height: 22px;

                    .l-text {
                        float: left;
                        margin-bottom: 0px;
                    }
                    .r-text {
                        float: right;
                        margin-bottom: 0px;
                    }
                }
            }
            .form-container {
                width: 1024px;
                margin: 0 auto;
                padding-top: 30px;
                padding-bottom: 30px;
            }

            /deep/ .el-loading-mask {
                margin-top: 100px;
            }
        }
    }
}
/deep/ .el-form .el-table__body {
    line-height: normal;
}
// .wflow-container-loaded{
//     height: calc(100vh - 40px)!important;
// }
/deep/ .el-upload {
    // width: 100%;
}
</style>
